import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LaloLockup from '../components/brand/LaloLockup';
import { KioskPinPad } from '../components/time/KioskPinPad';
/**
 * Kiosk-only view - PUBLIC ROUTE
 *
 * This page is a standalone interface with NO admin context:
 * - No sidebar
 * - No header
 * - No authentication required
 * - Just the PIN pad for employees to clock in/out
 *
 * Workflow:
 * 1. Admin enables kiosk mode at /settings/kiosk-setup
 * 2. System creates session and redirects here
 * 3. Admin tokens are cleared
 * 4. This page shows only PIN pad (fullscreen)
 */
export default function KioskOnlyPage() {
    return (_jsx("div", { className: "min-h-screen bg-ink flex items-center justify-center p-4", children: _jsxs("div", { className: "w-full max-w-md", children: [_jsxs("div", { className: "flex flex-col items-center mb-8", children: [_jsx(LaloLockup, { variant: "stacked" }), _jsx("p", { className: "mt-4 text-white/60", children: "Time Clock" })] }), _jsx(KioskPinPad, {}), _jsxs("div", { className: "mt-8 text-center text-xs text-white/40", children: [_jsx("p", { children: "Secure time tracking with PIN authentication" }), _jsx("p", { className: "mt-1", children: "For assistance, contact your administrator" })] })] }) }));
}
